import { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import { MenuItem, makeStyles } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import NgpSelect from '../../form/NgpSelect';
import { DASHBOARDS_ADMIN_USERID_FIELD } from './DashboardsAdminConstants';
import { useDataService } from '../../../services/ApiDataService';
import { useUser } from '../../../stores/SessionStore';

const useStyles = makeStyles({
    selectField: {
        marginRight: '16px',
        '& .MuiInput-root': {
            width: 280,
        },
    },
});

const nulUserValue = 'null_user';

export function DashboardsAdminUsersSelect({ formData }) {
    const [menuItems, setMenuItems] = useState([]);
    const styles = useStyles();
    const [currentUser] = useUser();
    const dataService = useDataService();
    const { setValue } = useFormContext();

    useEffect(() => {
        (async () => {
            const usersData = await dataService.get('/ipm/v1/admin/users');
            const currentUserMenuItem = {
                key: currentUser.userName,
                value: currentUser._id,
            };
            const userSelectMenuItems = usersData
                .map((userData) => {
                    return {
                        key: userData.userName,
                        value: userData._id,
                    };
                })
                .filter((userMenuItem) => userMenuItem.value !== currentUser._id)
                .sort((a, b) => a.key.localeCompare(b.key));

            setMenuItems([currentUserMenuItem, ...userSelectMenuItems]);
        })();
    }, [dataService, currentUser]);

    useEffect(() => {
        if (formData?.userId === null) {
            setValue(DASHBOARDS_ADMIN_USERID_FIELD, nulUserValue);
        }
    }, [formData, setValue]);

    return (
        <NgpSelect fieldName={DASHBOARDS_ADMIN_USERID_FIELD} label={t`Owner`} className={styles.selectField} required>
            {[
                <MenuItem key="--" value={nulUserValue}>
                    --
                </MenuItem>,
                ...menuItems.map((menuItem) => (
                    <MenuItem key={menuItem.key} value={menuItem.value}>
                        {menuItem.key}
                    </MenuItem>
                )),
            ]}
        </NgpSelect>
    );
}
